<template>
    <div class="transaction-details-list">
        <status-tabs :status.sync="status" :statusList="statusList" :funcName="funcName"></status-tabs>

        <search-tool ref="searchTool" :status="status" :statusList="statusList" :funcName="funcName"
            :searchForm="searchForm" :searchList="searchList" :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields" listName="transactionDetails" :loading="loading" :inputPlaceholder="inputPlaceholder" :selected="selectList.length">
        </search-tool>

        <div class="table" :style="{ height: height }">
            <el-table :data="tableData" ref="tableData" height="100%" row-key="id"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column align="left" label="Transaction No." prop="transaction_no">
                </el-table-column>
                <el-table-column align="left" label="Type" prop="type_cn">
                    <template slot-scope="scope">
                        <span class="general-table-tag" :class="[
                            scope.row.type == 1 ? 'danger' : 'primary',
                        ]">
                            <i class="el-icon-s-help"></i>
                            {{ scope.row.type_cn }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="Action" prop="action">
                </el-table-column>
                <el-table-column align="left" label="Relation No." prop="relation_no">
                </el-table-column>
                <el-table-column align="left" label="Payment No." prop="payment_no">
                </el-table-column>
                <el-table-column align="left" label="Payment Method" prop="payment_method">
                </el-table-column>
                <!-- <el-table-column align="left" label="Currency" prop="currency">
                </el-table-column> -->
                <el-table-column align="left" label="Amount" prop="amount">
                    <template slot-scope="scope">
                        <div class="col-amount" :style="{
                            color:
                                scope.row.type == 2 ? '#f56c6c' : '#635cff',
                        }">
                            <span>{{ scope.row.type == 1 ? "-" : "+" }}</span>
                            {{ scope.row.currency + scope.row.amount }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="Balance" prop="balance">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.currency + scope.row.balance }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="Company" prop="corp_name" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="left" label="Remark" prop="remark">
                </el-table-column>
                <el-table-column align="left" label="Complete Time" prop="created_at">
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination :paginationData="paginationData" @paginationChange="paginationChange" :funcName="funcName">
        </pagination>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Transation NO.、Relation NO.、Payment NO.、Company",
            searchForm: {
                keyword: "",
                action: "",
            },
            searchForm_transfer: {
                action: "",
            },
            funcName: "transactionDetails",
            selectList: [],
            actionList: ["Recharge","Order","Order refund","Withdrawal"],
            advanceSearchFields: {
                action: {
                    label: "Action",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        // 获取交易明细列表
        transactionDetails(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .transactionDetails(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {
                goods_name: "",
                sku: "",
                itemID: "",
            };
            this.searchForm_transfer = {};
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.transactionDetails();
            this.advanceSearchFields.action.options = this.searchList[0].props.list = this.actionList.map(item=>{
                return {
                    label: item,
                    value: item
                }
            });
        },
    },
    activated() {
        this.initialize();
    },
    components: {},
    computed: {
        searchList() {
            return [
                {
                    label: "Action",
                    key: "action",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "country",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.transaction-details-list {
    width: 100%;
    height: 100%;
    background: #fff;

    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }

        .col-amount {
            color: var(--col-color);
        }
    }
}
</style>
